import { EXTEND_SHORT_DESCRIPTION } from "../../../lms-admin-impl/i18n/extendShortDescription.i18n";

export const SHORT_DESCRIPTION: { [key: string]: string } = {
	short_description: "Kurzbeschreibung",
	...EXTEND_SHORT_DESCRIPTION,
};
